export type NewsletterUnsubscribeResult = {
  ok: boolean;
  message: string;
};

export async function unsubscribeNewsletter(token: string): Promise<NewsletterUnsubscribeResult> {
  try {
    const response = await fetch(`/api/newsletter/unsubscribe?Token=${encodeURIComponent(token)}`, {
      credentials: 'include',
      headers: { Accept: 'application/json' },
    });
    const data = (await response.json().catch(() => ({}))) as { ok?: boolean; message?: string };
    return {
      ok: Boolean(data.ok),
      message: data.message || (data.ok ? '已為您取消訂閱。' : '取消訂閱失敗，請稍後再試。'),
    };
  } catch {
    return { ok: false, message: '網路連線異常，請稍後再試。' };
  }
}
